// Simple localStorage draft manager with online-sync capability.
import { useEffect, useState, useRef } from "react";

const KEY_PREFIX = "mlily_draft_";

export function loadDraft(key) {
  try {
    const raw = localStorage.getItem(KEY_PREFIX + key);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}
export function saveDraft(key, value) {
  try { localStorage.setItem(KEY_PREFIX + key, JSON.stringify({ value, savedAt: Date.now() })); } catch {}
}
export function clearDraft(key) {
  try { localStorage.removeItem(KEY_PREFIX + key); } catch {}
}
export function listDrafts(prefix = "") {
  const out = [];
  for (let i = 0; i < localStorage.length; i++) {
    const k = localStorage.key(i);
    if (k && k.startsWith(KEY_PREFIX + prefix)) {
      try {
        const v = JSON.parse(localStorage.getItem(k));
        out.push({ key: k.slice(KEY_PREFIX.length), ...v });
      } catch {}
    }
  }
  return out;
}

/** React hook: auto-save `data` to a key with debounce; also track online state. */
export function useAutosaveDraft(key, data, enabled = true, debounceMs = 600) {
  const [savedAt, setSavedAt] = useState(null);
  const [online, setOnline] = useState(typeof navigator !== "undefined" ? navigator.onLine : true);
  const timer = useRef(null);
  useEffect(() => {
    if (!enabled) return;
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      saveDraft(key, data);
      setSavedAt(new Date());
    }, debounceMs);
    return () => timer.current && clearTimeout(timer.current);
  }, [key, data, enabled, debounceMs]);
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); };
  }, []);
  return { savedAt, online };
}
